<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
}
</script>
<style>
* {
  box-sizing: border-box;
}
html {
  text-size-adjust: auto;
}
body {
  /* 定死font-size 避免浏览器不同导致样式错乱 */
  font-size: 16px;
  margin: 0;
  padding: 0;
  /* 手机端显示不乱 */
  /* min-width: 1200px; */
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
textarea,
p,
blockquote,
th,
td,
input,
select,
textarea,
button {
  margin: 0;
  padding: 0;
} /* 初始化标签在所有浏览器中的margin、padding值 */
fieldset,
img {
  border: 0 none;
} /* 重置fieldset（表单分组）、图片的边框为0*/
dl,
ul,
ol,
menu,
li {
  list-style: none;
} /* 重置类表前导符号为onne,menu在HTML5中有效 */

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
/* 修改element 滚动条源码 */
#app .el-scrollbar__wrap {
  overflow-x: hidden;
}
#app .el-scrollbar__thumb {
  background: #78abdf;
}
 .el-message-box{
  margin-top: -400px;
}
</style>
